/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { IArena, IArenaInterface } from "../IArena";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "arenaId",
        type: "uint256",
      },
    ],
    name: "arena",
    outputs: [
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "token_uri",
            type: "string",
          },
          {
            internalType: "address",
            name: "platformAndArenaFeeCurrency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "platformAndArenaFee",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "arenaMap",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "surface",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "distance",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "weather",
            type: "uint32",
          },
        ],
        internalType: "struct Arena.Struct",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class IArena__factory {
  static readonly abi = _abi;
  static createInterface(): IArenaInterface {
    return new utils.Interface(_abi) as IArenaInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): IArena {
    return new Contract(address, _abi, signerOrProvider) as IArena;
  }
}
